import { PushNotificationsPopupDumb } from './PushNotificationsPopupDumb';

import { usePopupPushNotifications } from '@/hooks/usePopupPushNotifications';
import {
  reallyAskForPermissionNatively,
  rememberRejection,
  rememberDismiss,
} from '@/services/pushNotifications';

/**
 * Determina si se debe mostrar el popup y maneja la respuesta.
 * "PushNotificationsPopupDumb" es el componente de presentación asociado.
 * @returns
 */
export const PushNotificationsPopup = () => {
  const { popupAtom, setPopupAtom } = usePopupPushNotifications();

  function handleResponse(response: 'accept' | 'reject' | 'dismiss') {
    if (response === 'accept') {
      // console.log('User accepted notifications');
      setPopupAtom({ show: false });
      reallyAskForPermissionNatively();
    } else if (response === 'dismiss') {
      // console.log('User dismissed the popup');
      setPopupAtom({ show: false });
      rememberDismiss();
    } else {
      // console.log('User rejected notifications');
      setPopupAtom({ show: false });
      rememberRejection();
    }
  }

  return (
    <PushNotificationsPopupDumb
      handleResponse={handleResponse}
      isOpen={popupAtom.show}
    />
  );
};
